import React from 'react';

const ShareContext = React.createContext('report');

export const ShareContextProvider = ShareContext.Provider;

export default ShareContext;
